// Helpers de rubro de marca/empresa.
//
// El rubro vive en `brand_profiles.rubro` y en `company_profiles.rubro` (text
// libre, alimentado por el select cerrado de `OnboardingSelects.tsx`). Hoy la
// comparación está duplicada como string literal en varios lugares
// (`VariantForm.tsx`, `GeneratedImagesInline.tsx`, `EscenaPersonalizadaOption.tsx`,
// `BibliotecaOption.tsx`). Este módulo existe para no sumar una duplicación más
// al agregar "Muebles" — ver ADR-585.
//
// No se refactorizaron los usos existentes a propósito: ensuciaría el diff de la
// rama del modo muebles. Cuando haya que tocarlos por otra razón, migrarlos acá.

export const RUBRO_MUEBLES = 'Muebles';

/**
 * Rubro que habilita los modos de muebles (`catalogo-muebles` e `infografia`)
 * — ver ADR-2026-07-31-modos-muebles-por-rubro-de-marca.
 *
 * Es el label EXACTO de `rubroOptions` (`components/OnboardingSelects.tsx`) y el
 * que escribe el onboarding nuevo (`categoria hogar` → este string, ver
 * `onboarding/accountSetup.ts`). El texto está duplicado en varios archivos como
 * literal; acá vive la única copia que decide gating de modos.
 */
export const RUBRO_HOGAR_DECO = 'Hogar y Decoración';

/**
 * `true` si la marca es del rubro Muebles.
 *
 * Es una comparación exacta contra el valor del select. `rubro` es text libre en
 * la base, así que alguien podría tener "muebles" en minúscula o "Mueblería"
 * escritos a mano y no matchear. Se acepta a sabiendas: la única consecuencia es
 * que no se le autocompletan las medidas al importar de Tienda Nube, y la puede
 * cargar a mano igual. Si el caso aparece seguido, normalizar acá.
 */
export const esRubroMuebles = (rubro?: string | null): boolean =>
  rubro === RUBRO_MUEBLES;

/**
 * `true` si el rubro es "Hogar y Decoración" — el gate de visibilidad de los
 * modos "Catálogo de muebles" e "Infografías" (ADR-2026-07-31-modos-muebles-por-rubro-de-marca).
 *
 * Se compara contra el rubro de la **marca activa** (`brand_profiles.rubro`),
 * NO contra el de la empresa: una misma cuenta puede tener una marca de deco y
 * otra de indumentaria, y los modos solo tienen sentido en la primera. Usar el
 * hook `useRubroMarcaActiva` para obtener ese valor.
 *
 * Comparación exacta, igual que `esRubroMuebles`: si la marca quedó con el
 * rubro vacío (`null`), los modos NO se muestran — es la decisión explícita
 * (nada de fallback al rubro de la empresa). El usuario lo destraba cargando el
 * rubro de la marca desde Configuración → Mi marca.
 *
 * El rubro legacy `Muebles` NO entra: el onboarding nuevo ya no lo ofrece
 * (no tiene card en el paso 2) y se decidió gatear solo por "Hogar y Decoración".
 */
export const esRubroHogarDeco = (rubro?: string | null): boolean =>
  rubro === RUBRO_HOGAR_DECO;
